import "./Home.css";

const TECH_STACK = ["React", "JavaScript", "Node.js", "Symfony", "Docker"];

export default function Home() {
  return (
    <section id="home" className="home-section">
      <div className="container">
        <div className="home-layout">
          <div className="home-copy reveal-left">
            <span className="home-badge">Pret a concevoir des experiences fortes</span>

            <h1 className="home-title">
              Developpeur
              <br />
              <span>Full-Stack</span>
            </h1>

            <p className="home-subtitle">
              J'imagine et je developpe des interfaces modernes, rapides et
              credibles pour donner de la valeur a vos projets digitaux.
            </p>

            <div className="home-tech-list">
              {TECH_STACK.map((item, index) => (
                <span
                  key={item}
                  className="tech"
                  style={{ animationDelay: `${index * 90}ms` }}
                >
                  {item}
                </span>
              ))}
            </div>

            <div className="home-actions">
              <a href="#portfolio" className="home-btn home-btn-primary">
                Voir mes projets
              </a>
              <a href="#contact" className="home-btn home-btn-secondary">
                Me contacter
              </a>
            </div>
          </div>

          <div className="home-visual reveal-right">
            <div className="hero-frame glass-panel">
              <div className="hero-orbit hero-orbit-one" aria-hidden="true" />
              <div className="hero-orbit hero-orbit-two" aria-hidden="true" />
              <div className="hero-image">
                <img src="/img1.png" alt="Portrait d'Augustin" />
              </div>
              <div className="hero-card hero-card-top">
                <strong>Frontend</strong>
                
              </div>
              <div className="hero-card hero-card-bottom">
                <strong>Back-end </strong>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
